import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import { toast } from "react-toastify";
import FormFields from "./FormFields";
import { getPersonById, updatePerson } from "../../../redux/slices/persons/personsThunk";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const EditGrossistesPage = () => {
  const [form] = Form.useForm();
  // const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [oldDoc, setoldDoc] = useState({});

  useEffect(() => {
    dispatch(getPersonById(id)).then((data) => {
      setoldDoc(
        {
          government: data.payload?.government?.id,
          region: data.payload?.region?.id,
        })
      form.setFieldsValue(
        {
          firstname: data.payload.firstname,
          lastname: data.payload.lastname,
          companyName: data?.payload.wholesaler?.companyName,
          email: data.payload.email,
          phoneNumber: data.payload.phoneNumber,
          address: data.payload.address,
          region: data.payload?.region?.name,
          government: data.payload?.government?.name,
        }
      );
    }
    );

  }, [dispatch, id, form]);

  const onFinish = (values) => {
    const formattedValues = {
      nom: values.nom,
      code: values.code,
      email: values.email,
      phone: values.phone,
      type: values.type,
      address: values.address,
      companyName: values.companyName,
      region: {
        id: typeof values.region === "string" ? oldDoc.region : values.region,
      },
      government: {
        id: typeof values.government === "string" ? oldDoc.government : values.government,
      },
      representative: values.representative,
    };

    const personId = id
    dispatch(updatePerson({ personId, personData: formattedValues })).then(() => {
      navigateTo("/grossistes");
      toast.success("Grossiste modifié avec succès !");
    });
  };

  const onReset = () => {
    form.resetFields();
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Modifier un grossiste"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit">
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Réinitialiser
              </Button>
              <Button type="link" htmlType="button" onClick={() => navigateTo("/grossistes")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditGrossistesPage;
